import { render, staticRenderFns } from "./TabDesligamentos.vue?vue&type=template&id=5fc001cd"
import script from "./TabDesligamentos.vue?vue&type=script&lang=ts"
export * from "./TabDesligamentos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports